module.exports = __webpack_public_path__ + "media/images/shared/kqed-c62db4db5844f55b3ab65174512a4c6df740ba15ae0af94748a9b46fa234f52c.png";